export { Avatar, AvatarProps } from 'antd'
